import Masonry from 'masonry-layout';
import bus from '../util/eventBus';

const gridElements = document.querySelectorAll('.u-masonry');

window.addEventListener('load', () => {
  if (gridElements) {
    const gridOptions = {
      itemSelector: '.u-masonry__item',
      transitionDuration: 0,
      gutter: 0,
      percentPosition: true,
    };

    gridElements.forEach(gridEl => {
      if (gridEl.classList.contains('c-facts--grid')) {
        gridOptions.columnWidth = 1;
      }

      const grid = new Masonry(gridEl, gridOptions);

      if (gridEl.classList.contains('c-grid__main')) {
        gridEl.classList.add('is-visible');
      }

      bus.on('ewg-social-grid-recalc', () => {
        if (gridEl) {
          grid.reloadItems();

          const gridItems = gridEl.querySelectorAll('.u-masonry__item');
          const gridTwitterItems = Array.from(gridItems).filter(el =>
            el.classList.contains('c-tease--twitter'),
          );

          gridTwitterItems.forEach(el => {
            const innerImg = el.querySelector('.c-tease__content img');

            if (innerImg) {
              const img = new Image();
              img.onload = () => grid.layout();
              img.src = innerImg.getAttribute('src');
            }
          });
        }
      });

      bus.on('ewg-load-more', () => {
        bus.on('ewg-lazy-img-loaded', () => {
          grid.reloadItems();
          grid.layout();
        });
      });

      bus.on('ewg-facet-filtering', () => {
        bus.on('ewg-lazy-img-loaded', () => {
          grid.reloadItems();
          grid.layout();
        });
      });

      grid.on('layoutComplete', () => {
        bus.emit('ewg-grid-recalculated', true);
      });
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/masonry.js